// extracted by mini-css-extract-plugin
export var actions = "style-module--actions--7ed56";
export var normalContainer = "style-module--normalContainer--83ae7";
export var qrProductContainer = "style-module--qrProductContainer--13561";